import { render, staticRenderFns } from "./CreateFacultyModal.vue?vue&type=template&id=9b6dea50&scoped=true"
import script from "./CreateFacultyModal.vue?vue&type=script&lang=js"
export * from "./CreateFacultyModal.vue?vue&type=script&lang=js"
import style0 from "./CreateFacultyModal.vue?vue&type=style&index=0&id=9b6dea50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6dea50",
  null
  
)

export default component.exports